export default "__VITE_ASSET__LCj75_JQ__"